const HandleHashPaste = (event, hashRef) => {
    event.preventDefault();

    const pasteValue = event.clipboardData.getData('text').split('');
    pasteValue.forEach((char, index) => {
        if (hashRef.current[index]) {
            hashRef.current[index].value = char;
        }
    });
    const focusIndex = Math.min(pasteValue.length, hashRef.current.length) - 1;
    if (focusIndex >= 0) {
        hashRef.current[focusIndex].focus();
        hashRef.current[focusIndex].select();
    }
};

export default HandleHashPaste;